import { t } from "@web-monorepo/i18n/macro";
import { DDSIconButton } from "@web-monorepo/dds";
import { IconX } from "@web-monorepo/dds-icons";
import { once } from "es-toolkit/compat";
import React from "react";
import FullBleedScreen from "./BeyondToolkit/FullBleedScreen";
import fullBleedStyles from "./BeyondToolkit/FullBleedScreen.module.css";
import styles from "./ToolkitFullscreenAudioPlayer.module.css";

type ToolkitFullscreenAudioPlayerProps = {
  onClose: VoidFunction;
  sendUsage: VoidFunction;
  audioSrc: string;
  imgSrc: string;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
class ToolkitFullscreenAudioPlayer extends React.Component<ToolkitFullscreenAudioPlayerProps> {
  componentDidMount() {
    document.addEventListener("visibilitychange", this._onVisibilityChange);
  }

  componentWillUnmount() {
    document.removeEventListener("visibilitychange", this._onVisibilityChange);
  }

  render() {
    return (
      <FullBleedScreen>
        {/* Render the per-episode artwork as a real DOM element absolutely
            positioned behind the audio controls. Avoids `style={{ background: url(...) }}`
            inline-style on `<FullBleedScreen>` for what's a runtime URL. */}
        <img src={this.props.imgSrc} alt="" className={fullBleedStyles.imageBackdrop} />
        <div className={styles.content}>
          <div className={styles.closeButton}>
            <DDSIconButton
              variant="transparent"
              aria-label={t`Close`}
              data-name="toolkit_fullscreen_audio_player:close"
              tooltip={{ content: t`Close`, dataName: "toolkit_fullscreen_audio_player:close:tooltip" }}
              onClick={() => this.props.onClose()}
            >
              <IconX />
            </DDSIconButton>
          </div>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption -- educational audio content, captions not available */}
          <audio
            className={styles.audio}
            controls
            autoPlay
            src={this.props.audioSrc}
            ref={(node) => (this.audioNode = node)}
            onPlay={this._sendUsage}
            onEnded={() => this.props.onClose()}
          />
        </div>
      </FullBleedScreen>
    );
  }

  audioNode: HTMLAudioElement | null | undefined;

  _pause = () => {
    this.audioNode?.pause();
  };

  _onVisibilityChange = () => {
    if (document.hidden) {
      this.audioNode?.pause();
    }
  };

  _sendUsage = once(() => {
    this.props.sendUsage();
  });
}

export default ToolkitFullscreenAudioPlayer;
